import { GenericExportProgressModal } from './index';
import { DocChronologyExportEvent } from '@/api/hooks/useDocChronologyExportEvents';
import { APIBaseChronos } from '@/api/hosts';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  matterId: string;
  subsetId: string;
  docChronologyId: string;
  docChronologyTitle: string;
  exportId: string | null;
  onDownload: () => Promise<void>;
  isCreating: boolean;
  error?: string;
}

/**
 * Progress modal for document chronology exports with source documents.
 * Thin wrapper around GenericExportProgressModal with doc-chronology-specific configuration.
 */
export const DocChronologyExportProgressModal = ({
  isOpen,
  onClose,
  matterId,
  subsetId,
  docChronologyId,
  docChronologyTitle,
  exportId,
  onDownload,
  isCreating,
  error,
}: Props) => {
  return (
    <GenericExportProgressModal<DocChronologyExportEvent>
      isOpen={isOpen}
      onClose={onClose}
      exportConfig={{
        progressEndpoint: `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/doc-chronology/${docChronologyId}/export-progress`,
        exportId,
      }}
      itemName={`Document Chronology "${docChronologyTitle}"`}
      onDownload={onDownload}
      isCreating={isCreating}
      error={error}
    />
  );
};
